import { IKitItem, IPGKitItem } from '~api/KitsAPI/utils/IKits';

const mapKitName = (
    kitsAccum: { kitName: string; kitProductCodes: IPGKitItem[]; kitItems: IKitItem[] },
    kit: IPGKitItem,
    i: number
) =>
    i === 0
        ? kit['prod.PROD_RGN_NAME']
        : kit['prod.GIFTSET_COMPONENTS']
        ? `${kitsAccum.kitName} + ${kit['prod.PROD_RGN_NAME']}`
        : `${kit['prod.PROD_RGN_NAME']} + ${kitsAccum.kitName}`;

const mapKitProductCodes = (
    kitsAccum: { kitName: string; kitProductCodes: IPGKitItem[]; kitItems: IKitItem[] },
    kit: IPGKitItem
) =>
    kit['prod.GIFTSET_COMPONENTS']
        ? [...kitsAccum.kitProductCodes, kit['prod.FAMILY_CODE']]
        : [kit['prod.FAMILY_CODE'], ...kitsAccum.kitProductCodes];

const mapKitItems = (
    kitsAccum: { kitName: string; kitProductCodes: IPGKitItem[]; kitItems: IKitItem[] },
    kit: IPGKitItem
) =>
    kit['sku.SUPPRESS_IN_CART']
        ? kitsAccum.kitItems
        : [
              ...kitsAccum.kitItems,
              {
                  type: 'default', //add here new kit types, e.g: engraving.
                  subtype: 'default',
                  name: kit['prod.PROD_RGN_NAME'],
                  shade: kit['sku.SHADENAME'],
                  size: kit['sku.PRODUCT_SIZE'],
                  shadeCode: kit['sku.HEX_VALUE'] || kit['sku.HEX_VALUE_STRING'],
                  image:
                      kit['prod.THUMBNAIL_IMAGE'] ||
                      kit['sku.IMAGE_SMALL'] ||
                      kit['sku.SMALL_IMAGE'],
                  skuId: kit['sku.SKU_BASE_ID']
              }
          ];

export const generateKitInfo = (
    kitsAccum: { kitName: string; kitProductCodes: IPGKitItem[]; kitItems: IKitItem[] },
    kit: IPGKitItem,
    i: number
) => ({
    kitName: mapKitName(kitsAccum, kit, i),
    kitProductCodes: mapKitProductCodes(kitsAccum, kit),
    kitItems: mapKitItems(kitsAccum, kit)
});
